export enum ActionCode {
  // Insumos (FERT_SLOTS_REQ / FUEL_SLOTS_REQ)
  CREATE_REQUEST = "CREATE_REQUEST",
  CREATE_ORDERS = "CREATE_ORDERS",
  EDIT_ORDERS = "EDIT_ORDERS",
  REJECT_REQUEST = "REJECT_REQUEST",
  REJECT_REQUEST_ORDER_CREATED = "REJECT_REQUEST_ORDER_CREATED",
  REQUIRE_INFO = "REQUIRE_INFO",
  ASSIGN_DRIVER = "ASSIGN_DRIVER",
  REASSIGN_DRIVER = "REASSIGN_DRIVER",
  FILTER_LIST = "FILTER_LIST",
  CANCEL_ORDER = "CANCEL_ORDER",
  CANCEL_REQUEST = "CANCEL_REQUEST",
  DELIVER_ORDER = "DELIVER_ORDER",
}
